<script>
  import ReceiptBarcode from './ReceiptBarcode.svelte';
  import ReceiptDivider from './ReceiptDivider.svelte';

  let {
    lines = [],
    note = '',
    showBarcode = true,
    timestamp = '',
  } = $props();
</script>

<div class="receipt-footer">
  <ReceiptDivider variant="dashed" spacing="sm" />

  {#if lines.length > 0}
    <div class="receipt-footer__lines">
      {#each lines as line}
        <span class="receipt-footer__line">{line}</span>
      {/each}
    </div>
  {/if}

  {#if note}
    <p class="receipt-footer__note">{note}</p>
  {/if}

  {#if timestamp}
    <span class="receipt-footer__timestamp">PRINTED: {timestamp}</span>
  {/if}

  {#if showBarcode}
    <div class="receipt-footer__barcode">
      <ReceiptBarcode code={timestamp || 'RECEIPT'} height={36} />
    </div>
  {/if}


</div>

<style>
  .receipt-footer {
    width: 100%;
    text-align: center;
  }

  .receipt-footer__lines {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 8px 0;
  }

  .receipt-footer__line {
    font-family: var(--font-mono);
    font-size: 11px;
    color: var(--receipt-text-muted);
    letter-spacing: 0.5px;
  }

  .receipt-footer__note {
    font-family: var(--font-mono);
    font-size: 12px;
    color: var(--receipt-text-secondary);
    margin: 6px 0;
    line-height: 1.5;
  }

  .receipt-footer__timestamp {
    display: block;
    font-family: var(--font-mono);
    font-size: 10px;
    color: var(--receipt-text-muted);
    letter-spacing: 1px;
    margin: 6px 0;
  }

  .receipt-footer__barcode {
    margin: 10px 0;
  }

</style>
